import { makeVar } from '@apollo/client'

// `memoryButtonSelected` and `memoryShowHints` were removed on 22 September 2026 — with the
// number row gone (the digit is chosen from the cell menu) and the solution button off, no
// component read them any more.
export const memoryCurrentGame = makeVar()
export const memoryReloadGames = makeVar()
